import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { View, BodyText, Title } from 'modules/styled';
import Web3Warning from 'modules/wallet/web/web3Warning/web3Warning.component';
import { useCurrentWarning } from 'modules/wallet/web/web3Warning/web3Warning.hooks';
import { connectAddress } from 'modules/wallet/wallet.actions';
import { usePrice } from 'modules/wallet/price.context';
import { CashoutFooter } from './cashoutFooter';
import { useWeb3, useWeb3React, useRelParam, useSRelParam } from 'web3/hooks';
import { fromBNDec } from 'web3/utils';

AddEthAddress.propTypes = {
  close: PropTypes.func,
};

export default function AddEthAddress({ close }) {
  useWeb3();
  const { account } = useWeb3React();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const canClaim = user.balance - (user.airdropTokens || 0);

  const warning = useCurrentWarning({
    user,
    canClaim,
  });

  const title = warning
    ? 'Connect Your Ethereum Wallet'
    : 'Ethereum Address is Connected';

  return (
    <View>
      <Title>{title}</Title>
      {warning ? (
        <Web3Warning
          connectAddress={() => dispatch(connectAddress(account))}
          warning={warning}
        />
      ) : (
        <Connected close={close} account={account} />
      )}
    </View>
  );
}

Connected.propTypes = {
  account: PropTypes.string,
};

function Connected({ account }) {
  const { res: balanceBN = 0 } = useRelParam('balanceOf', [account]);
  const { res: sRelbalanceBN = 0 } = useSRelParam('staked', [account]);
  const balance = fromBNDec(balanceBN);
  const sRelBalance = fromBNDec(sRelbalanceBN);
  const usdAmount = usePrice(balance, 'number');

  return (
    <Fragment>
      <BodyText sx={{ mt: 4 }}>Connected account: {account}</BodyText>
      <BodyText sx={{ mt: 2 }}>
        Balance in Ethereum wallet: {balance} REL{usdAmount ? ` ($${usdAmount})` : null},{' '}
        {sRelBalance} sRel
      </BodyText>
      <CashoutFooter />
    </Fragment>
  );
}
